import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTPageLayout from '../common/RTPageLayout';
import Tile from '../common/Tile';
import RequireMenuAccess from '../common/RequireMenuAccess';
import '../common/rtCommon.css';
import './PGManagement.css';

const tiles = [
  {
    title: 'Add Paying Guest Details',
    permissionKey: 'paying-guest.add',
    icon: '🧑',
    description: 'Add a new paying guest.',
    url: 'add',
  },
  {
    title: 'View Paying Guest',
    permissionKey: 'paying-guest.view',
    icon: '👀',
    description: 'View and manage all your paying guest details.',
    url: 'list',
  },
];

const PGManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RequireMenuAccess>
      <RTPageLayout
        title="Paying Guest Management"
        mainSection
        activePath={location.pathname}
      >
        <div className="rt-tiles-grid">
          {tiles.map((tile, idx) => (
            <Tile
              key={idx}
              title={tile.title}
              icon={tile.icon}
              description={tile.description}
              permissionKey={tile.permissionKey}
              onClick={() => tile.url && navigate(tile.url)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => {
                if (e.key === 'Enter' && tile.url) navigate(tile.url);
              }}
            />
          ))}
        </div>
      </RTPageLayout>
    </RequireMenuAccess>
  );
};

export default PGManagement;
